import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import { DepositFeeWarningProps } from "./types";
import { AlertSign } from "@letsbit/milkylb";
import { FEE_TYPE } from "@letsbit/malcolmlb";
import { useFormatter } from "hooks/utils/useFormatter";

export const DepositFeeWarning: React.FC<DepositFeeWarningProps> = ({
  currency,
  currency_network,
}) => {
  const { formatValue } = useFormatter();

  const fee_per = currency_network.deposit_fee_percentage
    ? +currency_network.deposit_fee_percentage * 100
    : null;
  const fee_value = currency_network.deposit_fee_value
    ? +currency_network.deposit_fee_value
    : null;

  const textCalculation = () => {
    switch (currency_network.fee_type) {
      case FEE_TYPE.PERCENTAGE:
        return fee_per && +fee_per > 0 ? (
          <FormattedMessage
            {...messages.comissionMessage}
            values={{
              fee: `${fee_per} %`,
            }}
          />
        ) : null;
      case FEE_TYPE.VALUE:
        return fee_value && +fee_value > 0 ? (
          <FormattedMessage
            {...messages.comissionMessage}
            values={{
              fee: `${formatValue(
                fee_value.toString(),
                currency.precision,
              )} ${currency.ticker_id.toUpperCase()}`,
            }}
          />
        ) : null;
      case FEE_TYPE.BOTH:
        return fee_per && fee_value && fee_per > 0 && +fee_value > 0 ? (
          <FormattedMessage
            {...messages.bothMessage}
            values={{
              pn: currency_network.payment_network.name,
              fee_per,
              fee_value,
              currency: currency.ticker_id.toUpperCase(),
            }}
          />
        ) : null;
    }
  };

  const text = textCalculation();

  return text ? <AlertSign text={text} /> : null;
};
